import {request} from '@/helpers/apiClient'
import {DROPDOWN_CONFIG} from '@/utils/constants/apiConfig/dropdownConfig'
import { POINT_MULTIPLIER_CONFIG } from '@/utils/constants/apiConfig/pointMutliplierConfig'
import {DROPDOWN_TYPES} from '@/utils/constants/dropdownConstants'

export const handleGetDropdownList = async dropdownType => {
  switch (dropdownType) {
    case DROPDOWN_TYPES.SalesTargetType:
      return await request(DROPDOWN_CONFIG.SALES_TYPE_DROPDOWN_LIST)
    case DROPDOWN_TYPES.ActivitiesType:
      return await request(DROPDOWN_CONFIG.ACTYVITY_TYPE_DROPDOWN_LIST)
    case DROPDOWN_TYPES.StoreSelector:
      return await request(DROPDOWN_CONFIG.STORE_SELECTOR_DROPDOWN_LIST)
    case DROPDOWN_TYPES.Actions:
      return await request(DROPDOWN_CONFIG.ACTIONS_DROPDOWN_LIST)
    case DROPDOWN_TYPES.Schedule:
      return await request(DROPDOWN_CONFIG.SCHEDULE_DROPDOWN_LIST)
    case DROPDOWN_TYPES.PointMultiplierRulesCriteria:
      return await request(POINT_MULTIPLIER_CONFIG.RULES_CRITERIA_DROPDOWN_LIST)
    case DROPDOWN_TYPES.PointMultiplierSegment:
      return await request(POINT_MULTIPLIER_CONFIG.SEGMENT_DROPDOWN_LIST)
    case DROPDOWN_TYPES.PointMultiplierCategory:
      return await request(POINT_MULTIPLIER_CONFIG.CATEGORY_DROPDOWN_LIST)
    case DROPDOWN_TYPES.PointMultiplierChannel:
      return await request(POINT_MULTIPLIER_CONFIG.ORDER_CHANNEL_DROPDOWN_LIST)
    default:
      throw new Error(`Unsupported dropdown type: ${dropdownType}`)
  }
}
